
function toggleContent() {  
    const content = document.getElementById('content');  
    const toggleButton = document.getElementById('toggleButton');  

    if (content.classList.contains('hidden')) {  
        content.classList.remove('hidden');  
        toggleButton.innerText = 'Show Less';  
    } else {  
        content.classList.add('hidden');  
        toggleButton.innerText = 'Read More';  
    }  
}


document.querySelectorAll('.tab').forEach(tab => {  
    tab.addEventListener('click', () => {  
        // Hide all accordion content  
        document.querySelectorAll('.accordion-content').forEach(content => {  
            content.style.display = 'none'; // Hide all content  

            // Remove active class from parent element  
            const parent = content.parentElement;  
            if (parent) {  
                parent.classList.remove('active');  
            }  
        });  

        // Show specific content  
        const targetContent = document.getElementById(tab.dataset.target);  
        if (targetContent) {  
            targetContent.style.display = 'block'; // Show specific content  

            // Add active class to parent element  
            const parent = targetContent.parentElement;  
            if (parent) {  
                parent.classList.add('active');  
            }  
        }  
    });  
});